/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 */
import React, { ReactNode } from 'react'

import AssetTableCell from './AssetTableCell'
import { formatDate12 } from './utils'

type OfflineSinceColProps = {
  addressSampleTime?: Date
  gatewayOn: boolean
}

const OfflineSinceCol: React.FC<OfflineSinceColProps> = ({ gatewayOn, addressSampleTime }) => {
  let displayValue: ReactNode = <div className="h-4 w-full flex"></div>
  if (!gatewayOn) {
    displayValue = addressSampleTime ? formatDate12(addressSampleTime) : ''
  }

  return <AssetTableCell>{displayValue}</AssetTableCell>
}

export default OfflineSinceCol
